module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/core-js/modules/_html.js
// module id = 81
// module chunks = 1